export default __webpack_public_path__ + "static/media/iron.ad000515.jpg";